import { Component, Inject, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";

import { Observable } from "rxjs";

import { ActionLogStatus } from "../core/enums/cases/ActionLogStatus";
import { date } from "../utils/date";
import * as moment from "moment";
import { SetActionLogStatusCommand } from "../DTOs/Cases/Commands/SetActionLogStatusCommand";
import { AppConfigService, AppConfig } from "../services/app-config.service";
import { AuthService } from "../auth/auth.service";

import * as signalR from "@microsoft/signalr";
import { map } from "rxjs/operators";
import { HubConnection } from "@microsoft/signalr";



@Injectable()
export class CasesService implements OnInit {
  public appConfig: AppConfig = new AppConfig();

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
    private authService: AuthService
  ) {
    this.appConfig = this.appConfigService.getConfig();
    this.getSignalRInfo = this.getSignalRInfo.bind(this);
  }

  ngOnInit(): void {}

  // ---------------------------------------------------------
  // get Actioned By - begin
  // ---------------------------------------------------------
  getActionedBy(
    Status: number,
    ActionedByUserName: string,
    ActionedByWhen: Date
  ): string {
    

    let ActionedBy = "";

    // set Actioned By - begin
    let tmpActionedBy = "";
    switch (Status) {
      case ActionLogStatus.Value("Acknowledged"): {
        tmpActionedBy = "Acknowledged by";
        break;
      }
      case ActionLogStatus.Value("Chatted"): {
        tmpActionedBy = "Chatted by";
        break;
      }
      case ActionLogStatus.Value("Contacted"): {
        tmpActionedBy = "Contacted by";
        break;
      }
    }

    if (tmpActionedBy != "") {
      ActionedBy =
        tmpActionedBy +
        " " +
        ActionedByUserName +
        " " +
        moment(ActionedByWhen).format("DD MMM YYYY HH:mm A");
    } else {
      ActionedBy = "";
    }

    // set Actioned By - end

    if (environment.debug_mode) {
      console.log(
        "getActionedBy, Status: " + Status + " return: " + ActionedBy
      );
    }

    return ActionedBy;
  }

  // ---------------------------------------------------------
  // get Actioned By - end
  // ---------------------------------------------------------

  // ---------------------------------------------------------
  // setNotificationActionedBy - begin
  // ---------------------------------------------------------
  setActionLogStatus(cmd: SetActionLogStatusCommand) {
    

    const url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_appointments_url +
      "actionlogstatus";

    if (environment.debug_mode) {
      console.log("setActionLogStatus, url: " + url);
    }

    return this.http.put<any>(url, JSON.stringify(cmd));
  }

  // ---------------------------------------------------------
  // setNotificationActionedBy - end
  // ---------------------------------------------------------

  // ----------------------------------------------------------
  // add chat message - begin
  // ----------------------------------------------------------
  /*addChatMessage(NotificationID: string, chatMessages: CaseChatMessage[], status: string, actionedByUserID: string, actionedByUserName: string): Observable<any> {


      var addChatMsg =  null;

      if (status != String(ActionLogStatus.Value("Unactioned")))
      {
          addChatMsg = {
              id: NotificationID as string,
              ChatMessages: chatMessages
          }
      }
      else
      {
          addChatMsg = {
              id: NotificationID as string,
              ChatMessages: chatMessages as CaseChatMessage[],
              Status: String(ActionLogStatus.Value("Chatted")) as string,
              ActionedByUserID: actionedByUserID as string,
              ActionedByUserName: actionedByUserName as string,
              ActionedByWhen: date.getNowUtc()
          }
      }


      return this.http.patch<any>(this.cases_api_url + NotificationID,JSON.stringify(addChatMsg));
  }
  */
  // ----------------------------------------------------------
  // add chat message - end
  // ----------------------------------------------------------

  // ---------------------------------------
  // get Actioned List - begin
  // ---------------------------------------
  getActionedCases(
    orgId: string,
    qryCenter,
    qryCasesTypes,
    qryDoctors
  ): Observable<any> {
    

    return this.getActionLogs(orgId, 1, qryCenter, qryCasesTypes, qryDoctors);
  }

  // --------------------------------------
  // get Actioned List - end
  // --------------------------------------

  // ---------------------------------------
  // get ActionLogs - begin
  // ---------------------------------------
  getActionLogs(
    orgId: string,
    status: number,
    center: string,
    casesTypes: string[],
    doctors: string[]
  ): Observable<any> {
    

    const qryCenter: string = "&Center=" + center;

    const qryDoctors: string = "&Doctors=" + doctors.join();

    const qryCasesTypes: string = "&CaseTypes=" + casesTypes.join();

    const url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_appointments_url +
      "actionLogs?Status=" +
      status +
      qryCenter +
      qryCasesTypes +
      qryDoctors;

    if (environment.debug_mode) {
      console.log("getActionLogs url: " + url);
    }

    return this.http.get(url);
  }

  // --------------------------------------
  // get ActionLogs - end
  // --------------------------------------

  // -----------------------------------------------------------
  // get Unactioned Cases - begin
  // -----------------------------------------------------------
  getUnactionedCases(
    orgId: string,
    center: string,
    caseTypes: string[],
    doctors: string[]
  ): Observable<any> {
    

    return this.getActionLogs(orgId, 0, center, caseTypes, doctors);
  }

  // -----------------------------------------------------------
  // get Unactioned Cases - end
  // -----------------------------------------------------------

  // -----------------------------------------------------------
  // get ActionLog with PatientProcedureDays - begin
  // -----------------------------------------------------------
  // CURRENTLY NOT IN USE, SEE IN NODE.JS
  getActionLogPatientProcedureDays(
    patientprocedureid: string
  ): Observable<any> {
    

    const url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_appointments_url +
      "actionlogpatientproceduredays?patientproceduredayid=" +
      patientprocedureid;

    if (environment.debug_mode) {
      console.log("getActionLogPatientProcedureDays url: " + url);
    }
    return this.http.get(url);
  }

  // -----------------------------------------------------------
  // get ActionLog with PatientProcedureDays- end
  // -----------------------------------------------------------

  getSummary(selectedClinic: string): Observable<any> {
    

    const url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_appointments_url +
      "summary?centerId=" +
      selectedClinic;

    return this.http.get(url);
  }

  getActionCaseHistory(actionCaseId: string): Observable<any> {
    

    const url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_appointments_url +
      "history?actionCaseId=" +
      actionCaseId;

    return this.http.get(url);
  }

  stopMessages(appointmentEventIds: string[]): Observable<any> {
    

    const url: string =
      this.appConfig.oc_api_url + environment.oc_api_appointments_url + "stop";

    return this.http.post(url, appointmentEventIds);
  }

  stopMessagesCurnex(tenantId: string,patientId: string,stepInstanceId: string,skip:boolean=false): Observable<any> {
    const url: string =
      this.appConfig.curnex_api_url + 
      environment.curnex_skip_step +tenantId+"/patient/"+patientId+"/skipstep/"+stepInstanceId+"?skip="+skip;
      //to handle curnex text response type
    return this.http.get(url,{ responseType: 'text' });
  }

  forceSendMessage(appointmentEventId: string): Observable<any> {
    

    const url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_appointments_url +
      "forcesend";

    return this.http.post(url, appointmentEventId);
  }

  forceSendMessageCurnex(tenantId: string,patientId: string,stepInstanceId: string,newdateTimeUTC:string): Observable<any> {
    const url: string =
      this.appConfig.curnex_api_url +
      environment.curnex_skip_step +tenantId+"/patient/"+patientId+"/newexecuteDateTimeUTC/"+stepInstanceId+"?newExecuteDateTimeUTC="+newdateTimeUTC;
    return this.http.get(url,{ responseType: 'text' });
  }


  getBlobUrl(fileName: string): Observable<any> {
    

    const url: string = `${this.appConfig.oc_api_url}${environment.oc_api_storage_url}survey-file?fileName=${fileName}`;

    return this.http.get(url);
  }

  private hubConn: HubConnection;
   // -----------------------------------------------------------
  // cases web-sockets
  // -----------------------------------------------------------
  public async createAlertsUpdateConnection(): Promise<HubConnection> {
    if (!this.hubConn) {
      const that = this; // for use in the async lambda below
      const signalRInfo = await this.getSignalRInfo();
      const builder = new signalR.HubConnectionBuilder();
      builder.withUrl(signalRInfo.url, {
        accessTokenFactory: async () => {
          const signalRInfo = await that.getSignalRInfo();
          return signalRInfo.accessToken;
        }
      });
      this.hubConn = builder.build();
    }
    return this.hubConn;
  }

  private async getSignalRInfo() {
    const accessToken = await this.authService.getSignalRAccessToken().toPromise();
    const idToken = await this.authService.getIdToken().toPromise();
    const headers = new HttpHeaders({ "Authorization": `Bearer ${accessToken}` });
    const signalRInfo = await this.http.post<SignalRConnectionInfo>(`${this.appConfig.signalR_url}api/alerts/negotiate`, { idToken: idToken }, { headers: headers }).toPromise();
    return signalRInfo;
  }
}

export class SignalRConnectionInfo
{
  url:string;
  accessToken:string;
}
